const projectData = [
    {
        id:1,
        projectName:"Amazon Clone",
        demo:"https://amazoneccomerceapp.herokuapp.com/",
        imgsrc:"amazon.png"
    },
    {
        id:2,
        projectName:"Zomato Clone",
        demo:"https://amazoneccomerceapp.herokuapp.com/",
        imgsrc:"/zomatothumb.png"
    },
    {
        id:3,
        projectName:"Redux Todo App",
        demo:"https://react-reduxtodoapp.netlify.app/",
        imgsrc:"/todofirstthumb.png"
    },
    {
        id:4,
        projectName:"H & M Portfolio",
        demo:"https://hmdeveloper1.herokuapp.com/",
        imgsrc:"/zomatothumb.png"
    },
    {
        id:5,
        projectName:"Ecommerce Cart With Redux",
        demo:"https://react-redux-cart-youtube.netlify.app/",
        imgsrc:"/redux_thumb_done.png"
    },
    {
        id:6,
        projectName:"Crud App",
        demo:"https://react-redux-cart-youtube.netlify.app/",
        imgsrc:"/inonevideothumb.png"
    },
]

export default projectData;